/**
 * @module plugins/musicfavourite/adapter/knownErrors
 *
 * Singleton errors for known BBC iD and API error states.
 */
define('plugins/musicfavourite/adapter/knownErrors',[], function(exports) {

        'use strict';

        var knownErrors = {
            'NotSignedIn':  new Error('User is not signed in'),
            'ServiceError': new Error('Call to favourites API failed'),
            'LimitReached': new Error('Maximum number of favourites of this type has been reached'),
            'SignInCancelled': new Error('BBC iD sign in was cancelled'),
            'TokenRefreshFailed': new Error('Failed to refresh access tokens'),
            'UnsupportedType': new Error('Unsupported item type'),
            'IdUnavailable': new Error('BBCID is currently unavailable')
        };

        knownErrors.NotSignedIn.name = 'NotSignedIn';
        knownErrors.ServiceError.name = 'ServiceError';
        knownErrors.LimitReached.name = 'LimitReached';
        knownErrors.SignInCancelled.name = 'SignInCancelled';
        knownErrors.TokenRefreshFailed.name = 'TokenRefreshFailed';
        knownErrors.UnsupportedType.name = 'UnsupportedType';
        knownErrors.IdUnavailable.name = 'IdUnavailable';

        exports = knownErrors;

        return exports;
    }
);

